import {createContext, getContextOrThrow} from 'src/core';

const contextKey = Symbol('filter-buttons-context');
export const FILTER_BY_DEFAULT_EVENT = 'filter-by-default-event';

interface FilterButtonsContext {
    eventBus: EventTarget;
}

export function createFilterButtonsContext() {
    const eventBus = new EventTarget();

    return createContext<FilterButtonsContext>(contextKey, {
        eventBus
    });
}

export function getFilterButtonsContext(): FilterButtonsContext {
    return getContextOrThrow<FilterButtonsContext>(contextKey);
}